import { flow, types } from 'mobx-state-tree';
import { TMS_TOKEN_KEY } from '../../constants';
import { GetLogInModel } from '../../services/api/user';
import { IUserInfo, IUserInfoResolve } from '../../services/api/user.types';
import storage from '../../utils/storage';

export const UserInfoStoreModel = types
  .model('UserInfoStoreModel')
  .props({
    token: types.optional(types.string, ''),
    StaffId: types.optional(types.string, ''),
    UserName: types.optional(types.string, ''),
    CompanyId: types.optional(types.string, ''),
    CompanyName: types.optional(types.string, ''),
    DepartmentId: types.optional(types.string, ''),
    DepartmentName: types.optional(types.string, ''),
    GroupId: types.optional(types.string, ''),
    GroupName: types.optional(types.string, ''),
    PositionId: types.optional(types.string, ''),
    PositionName: types.optional(types.string, ''),
  })
  .actions((self) => {
    const setToken = (token: string) => {
      self.token = `Bearer ${token}`;
      storage.localSet(TMS_TOKEN_KEY, token);
    };

    const updateUserInfo = (user: IUserInfo) => {
      self.StaffId = user.StaffId;
      self.UserName = user.UserName;
      self.CompanyId = user.CompanyId;
      self.CompanyName = user.CompanyName;
      self.DepartmentId = user.DepartmentId;
      self.DepartmentName = user.DepartmentName;
      self.GroupId = user.GroupId;
      self.GroupName = user.GroupName;
      self.PositionId = user.PositionId;
      self.PositionName = user.PositionName;
    };
    const logout = () => {
      self.StaffId = '';
      self.UserName = '';
      self.CompanyId = '';
      self.CompanyName = '';
      self.DepartmentId = '';
      self.DepartmentName = '';
      self.GroupId = '';
      self.GroupName = '';
      self.PositionId = '';
      self.PositionName = '';
      self.token = '';
      storage.localRemove(TMS_TOKEN_KEY);
    };
    const requestUserInfo = flow(function* requestUserInfo() {
      const { Data, Code, Msg }: IUserInfoResolve = yield GetLogInModel();
      if (Code !== 200 && Code !== 0) {
        console.log(Msg);
      }
      updateUserInfo(Data);
    });

    // 钩子函数
    const afterCreate = () => {
      const token = storage.localGet(TMS_TOKEN_KEY);
      if (token && typeof token === 'string') {
        setToken(token);
      }
    };
    return {
      setToken,
      updateUserInfo,
      logout,
      requestUserInfo,
      afterCreate,
    };
  });
export const userInfoStore = UserInfoStoreModel.create();
